export default function CashUp() {
  return (
    <section className="sales-layout__page">
      <h1>Abschlüsse</h1>
      <p>Die Abschlüsse sind in Vorbereitung.</p>
    </section>
  );
}
